module.exports = __webpack_public_path__ + "img/baobiaob.ef899346.png";